module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-11.c287ebb9.jpg";